import React, {useEffect} from 'react';
import {useViewerStore} from "../../../../store/store";
import {SetCompassDeg} from "../Three-JS-Viewer/Controllers/CameraControl";
import CompassIcon from '../../../Pure-UI-Components/Icons/CompassIcon';

const Compass: React.FC = () => {
    const sceneViewer = useViewerStore((state) => state.sceneViewer);

    useEffect(() => {
        if (sceneViewer === null) return;

        const compass = document.getElementById('compassEle');
        if (!compass) return;

        let active = false;
        let angle = 0;
        let rotation = 0;
        let startAngle = 0;
        let center = {x: 0, y: 0};
        const R2D = 180 / Math.PI;

        function start(e: MouseEvent) {
            e.preventDefault();
            if (!sceneViewer.viewMode || sceneViewer.viewMode === '2d') return;

            if (sceneViewer.autoRotate) {
                sceneViewer.setAutoRotate(false);
            }

            sceneViewer.setCompassDrag(true);
            angle = (sceneViewer.camRot * R2D - 90) * -1;

            const bb = (e.target as HTMLElement).getBoundingClientRect();

            const {top: t, left: l, height: h, width: w} = bb;

            center = {
                x: l + w / 2,
                y: t + h / 2,
            };

            const x = e.clientX - center.x;
            const y = e.clientY - center.y;
            startAngle = R2D * Math.atan2(y, x);
            active = true;
        }

        const rotate = (e: MouseEvent) => {
            if (!sceneViewer.viewMode || sceneViewer.viewMode === '2d') return;
            e.preventDefault();

            const x = e.clientX - center.x;
            const y = e.clientY - center.y;
            const d = R2D * Math.atan2(y, x);
            rotation = d - startAngle;
            sceneViewer.setCameraAngle((angle + rotation) / R2D);

            SetCompassDeg(sceneViewer.camera, sceneViewer);
            compass.style.webkitTransform = `rotate(${angle + rotation}deg)`;
        };

        const stop = () => {
            if (sceneViewer.camera && active) {
                sceneViewer.setCompassDrag(false);
            }
            active = false;
        };

        compass.addEventListener('mousedown', start);

        const onMouseMove = (e: MouseEvent) => {
            if (active) {
                e.preventDefault();
                rotate(e);
            }
        };

        const onMouseUp = (_e: MouseEvent) => {
            stop();
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);

        return () => {
            compass.removeEventListener('mousedown', start);
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [sceneViewer]);

    return (
        <>
            <CompassIcon/>
        </>
    );
};

export default Compass;